export default __webpack_public_path__ + "static/media/img2.388d7905.jpg";